<template>
  <div class="details-panel" v-loading="showLoading">
    <common-header url="merchantAudit" />

    <el-tabs v-model="activeName">
      <el-tab-pane label="商户信息" name="1" lazy>
        <Info ref="info" :merId="merId" :formData="formData" />
      </el-tab-pane>
      <el-tab-pane label="企业情况" name="2" lazy>
        <Situation :type="1" :companyId="merId" :keyword="formData.merPermitName" />
      </el-tab-pane>
      <el-tab-pane label="关联分析" name="3" lazy>
        <Analysis :id="merId" :details="formData" />
      </el-tab-pane>
      <el-tab-pane label="经营情况" name="4" lazy>
        <Business :merId="merId" />
      </el-tab-pane>
      <el-tab-pane label="负责人信息" name="5" lazy>
        <Principal :merId="merId" :phone="formData.corpPhone" :formDataParent='formData' :letThrough="letThrough" />
      </el-tab-pane>
      <el-tab-pane label="关系验证" name="6" lazy>
        <Relation :merId="merId" />
      </el-tab-pane>
      <el-tab-pane label="审核报告" name="7" lazy>
        <Report :merId="merId" :letThrough="letThrough" />
      </el-tab-pane>
      <el-tab-pane label="合同查阅" name="8" lazy>
        <Contract-review :merId="merId" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  props: ['merId', 'letThrough'],
  components: {
    // Analysis: () => import('@/components/CorrelationAnalysis'),
    Analysis: () => import('./Tabs/Analysis'),
    Business: () => import('./Tabs/Business'),
    // Principal: () => import('@/components/PrincipalInfo'),
    Principal: () => import('./Tabs/Principal'),
    Relation: () => import('./Tabs/Relation'),
    Situation: () => import('@/components/BusinessSituation'),
    Report: () => import('./Tabs/Report'),
    Info: () => import('./Tabs/Info'),
    ContractReview: () =>
      import('@/components/DetailsMerchant/ContractReview/index')
  },
  data() {
    return {
      activeName: '1',
      showLoading: false,
      formData: {}
    }
  },

  created() {
    this.getDetails()
  },

  methods: {
    // 获取信息
    // 该模块每个tab的请求参数各不同，同一再detail获取到再通信给所有tab
    async getDetails() {
      const {
        merId,
        $store: { dispatch }
      } = this
      const dispatchEvent = 'public/getMerchantDetails'

      this.showLoading = true
      await dispatch(dispatchEvent, { merId }).then(res => {
        console.log(JSON.parse(JSON.stringify(res)), 'aa')
        this.formData = res
        this.showLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/detailsTabsPanel.scss';
</style>
